'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchHealthCheckData = exports.getHealthCheckData = exports.dataSelector = exports.LOAD_HEALTH_CHECK_DATA_SUCCESS = exports.LOAD_HEALTH_CHECK_DATA_REQUEST = exports.LOAD_HEALTH_CHECK_DATA_FAIL = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = require('../api');

var _reselect = require('reselect');

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_HEALTH_CHECK_DATA_FAIL = exports.LOAD_HEALTH_CHECK_DATA_FAIL = 'la/domain/healthcheck/LOAD_FAIL';
var LOAD_HEALTH_CHECK_DATA_REQUEST = exports.LOAD_HEALTH_CHECK_DATA_REQUEST = 'la/domain/healthcheck/LOAD_REQUEST';
var LOAD_HEALTH_CHECK_DATA_SUCCESS = exports.LOAD_HEALTH_CHECK_DATA_SUCCESS = 'la/domain/healthcheck/LOAD_SUCCESS';

// reducer
var DEFAULT_STATE = {
    data: {},
    loading: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LOAD_HEALTH_CHECK_DATA_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: false
            });
        case LOAD_HEALTH_CHECK_DATA_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: true
            });
        case LOAD_HEALTH_CHECK_DATA_SUCCESS:
            return (0, _extends3.default)({}, state, {
                data: action.payload,
                loading: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.healthcheck;
};

var dataSelector = exports.dataSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.data;
});

var getHealthCheckData = exports.getHealthCheckData = (0, _reselect.createSelector)(dataSelector, function (data) {
    return !(0, _isEmpty2.default)(data) ? data : false;
});

/* ACTION CREATORS */
var loadHealthCheckDataFail = function loadHealthCheckDataFail(error) {
    return {
        error: true,
        payload: error,
        type: LOAD_HEALTH_CHECK_DATA_FAIL
    };
};

var loadHealthCheckDataRequest = function loadHealthCheckDataRequest() {
    return {
        type: LOAD_HEALTH_CHECK_DATA_REQUEST
    };
};

var loadHealthCheckDataSuccess = function loadHealthCheckDataSuccess(HealthCheckData) {
    return {
        payload: HealthCheckData,
        type: LOAD_HEALTH_CHECK_DATA_SUCCESS
    };
};

var fetchHealthCheckData = exports.fetchHealthCheckData = function fetchHealthCheckData() {
    return function (dispatch) {
        dispatch(loadHealthCheckDataRequest());
        return _api.HealthCheck.fetchHealthCheckData().then(function (response) {
            dispatch(loadHealthCheckDataSuccess(response));
        }).catch(function (error) {
            dispatch(loadHealthCheckDataFail(error));
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/healthcheck.js
// module id = JhzB
// module chunks = 46